import styled from 'styled-components';

const ColorsListWrapper = styled.div`
  display: block;
`;

export { ColorsListWrapper };
